export enum EContractStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}
